import React from "react";
import { Field, reduxForm } from "redux-form";
import { required } from "../../../utils/formValidators";
import { renderRadioField } from "../../../utils/renderField";
import { AuthPaymentContainer } from "../../authenticated-payments/misc/auth-payment-container.component";
import { CardControlsRestartButton } from "../misc/card-controls-restart-button.component";
import LocateBranch from "../misc/locate-branch.component";
import Show from "../../../utils/show.component";

const ReplaceCardOptionsFormComponent = (props) => {
  // TODO: figure out why the form is being stored in state with an object for a name
  const formValues = (props.form["object Object"] && props.form["object Object"].values) || {};

  const onlineRadioValue = "online";
  const branchRadioValue = "branch";
  const phoneRadioValue = "phone";

  const getContinueDisabled = () => {
    return formValues.replaceCardOption != onlineRadioValue;
  }

  const submitForm = () => {
    window.scrollTo(0, 0);
    props.advanceToNextStep();
  };

  return (
    <AuthPaymentContainer title={"Card De-Activation and Replacement"}>
      <form onSubmit={props.handleSubmit(submitForm)}>
        <div className="row bold px-3 py-3">
          <h3 className="bold">Review the options below for your card de-activation and delivery of your new card.</h3>
        </div>
        <div class="radio-question" style={{flexDirection: "column"}}>
          <Field
            name="replaceCardOption"
            component={renderRadioField}
            type="radio"
            id={onlineRadioValue}
            label="De-activate card and order a replacement card online"
            value={onlineRadioValue}
            validate={[required]}
          />
          <ul className="pb-4">
            <li>Cost: $5</li>
            <li>Delivery: 7-10 business days</li>
          </ul>
          <Field
            name="replaceCardOption"
            component={renderRadioField}
            type="radio"
            id={branchRadioValue}
            label="De-activate card and receive a replacement card at a branch"
            value={branchRadioValue}
            validate={[required]}
          />
          <ul className="pb-4">
            <li>Cost: $5</li>
            <li>Delivery: Immediate! Your local branch will print you a new card to take home.</li>
          </ul>
          <Show condition={formValues.replaceCardOption == branchRadioValue}>
            <LocateBranch cardControls={props.cardControls}></LocateBranch>
          </Show>
          <Field
            name="replaceCardOption"
            component={renderRadioField}
            type="radio"
            id={phoneRadioValue}
            label="De-activate card and order a rush card over the phone"
            value={phoneRadioValue}
            validate={[required]}
          />
          <ul className="pb-4">
            <li>Cost: $30</li>
            <li>Delivery: 2-3 business days</li>
          </ul>
        </div>
        <Show condition={formValues.replaceCardOption == phoneRadioValue}>
          <div className="alert primary">
            We’re happy to help! Please call us at 888.267.7200. We’re here for you Monday through Friday 7am to 7pm, and Saturday 9am to 1pm.
          </div>
        </Show>
        <div className="row">
          <div className="col-12">
            <button
              disabled={getContinueDisabled()}
              className={"button full " + (!getContinueDisabled() ? "primary" : "")}
              type="submit"
            >
              Continue
            </button>
          </div>
        </div>
        <CardControlsRestartButton backToCards={props.backToCards} buttonText="Cancel" />
      </form>
    </AuthPaymentContainer>
  );
};

// Connect to Redux store
export const ReplaceCardOptionsForm = reduxForm({
  form: "ReplaceCard",
  destroyOnUnmount: false,
  initialValues: {
    replaceCardOption: ""
  },
})(ReplaceCardOptionsFormComponent);



// WEBPACK FOOTER //
// ./src/components/card-controls/forms/replace-card-options-form.component.js